import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'wtw-ui-components';
import { WtwUiComponentsModule } from 'wtw-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuestionContainerComponent } from './question-set/question-container/question-container.component';


@NgModule({
  declarations: [
    QuestionContainerComponent
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    WtwUiComponentsModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
  ],
  exports: [
    CommonModule,
    AppMaterialModule,
    WtwUiComponentsModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  
    QuestionContainerComponent
  ]
})
export class SharedModule { }
